module.exports = __webpack_public_path__ + "static/media/urbanLogo.3915ca19.svg";